import { dispatch, getState } from "../../state/store";
import {
  setDefaultLanguageFile,
  setLanguage,
  setLanguageFile,
  setLanguageList
} from "../../state/ducks";

import { log, awsStorageService } from "../../services";
import { PATH } from "./config";
import defaultLocalLang from "../../storage/web/public/lang/en.json";

const fetchLocalizationFile = async (code) => {
  let data;
  try {
    throw "mock";
    // eslint-disable-next-line no-unreachable
    const r = await awsStorageService.getFile(`${PATH}${code}.json`);
    data = JSON.parse(r);
    log.debug(`Success downloading the localize(${code}) file.`);
  } catch (e) {
    // log.error(`An error occurred while downloading the localize(${code}) file.`, e); TODO: uncomment when mock will be removed

    const { fetchLocalLocalizationFile } = await import("../local/localizationService");
    data = await fetchLocalLocalizationFile(code);
    log.info("Success setup default localize file");
  }
  return data;
};

const setLocale = async (code) => {
  // user selected language
  try {
    throw "mock";
    // eslint-disable-next-line no-unreachable
    const data = await fetchLocalizationFile(code);
    dispatch(setLanguage(code));
    dispatch(setLanguageFile(data));
    log.debug(`Successfully load localize(${code}) file.`);
    if (code === "en") {
      dispatch(setDefaultLanguageFile(data));
      log.info(`Successfully load default localize(${code}) file.`);
    }
  } catch (e) {
    // log.warn(`Error durring load localize(${code}) file.`, e); TODO: uncomment when mock will be removed
  }

  try {
    if (code !== "en") {
      const defaultData = await fetchLocalizationFile("en");
      dispatch(setDefaultLanguageFile(defaultData));
      log.info(`Successfully load default localize(${code}) file.`);
    }
  } catch (e) {
    log.warn(`An error occurred while load default localize(${code}) file.`, e);
  }
};

const t = (str_code, params) => {
  const state = getState();
  const lang = state.localization.lang;
  const defaultLang = state.localization.defaultLang;
  try {
    let word = lang[str_code] || defaultLang[str_code];
    if (!!word || word === "") {
      return word;
    }

    word = defaultLocalLang[str_code] || str_code;

    if (params) {
      Object.keys(params).forEach((key) => {
        word = word.replace(new RegExp(`\\{${key}\\}`, "g"), params[key]);
      });
    }

    return word;
  } catch (e) {
    return str_code;
  }
};

const loadLocalizationConfig = async () => {
  let data;
  try {
    throw "mock";
    // eslint-disable-next-line no-unreachable
    const r = await awsStorageService.getFile(`${PATH}config.json`);
    data = JSON.parse(r);
    log.debug("Success download market config file from s3 bucket");
  } catch (e) {
    // log.error(`An error occurred while downloading localization config`, e); TODO: uncomment when mock will be removed

    const { loadLocalLocalizationConfig } = await import("../local/localizationService");
    data = await loadLocalLocalizationConfig();
    log.info("Success setup default market config file");
  }
  dispatch(setLanguageList(data?.languages));
  return data;
};

export { setLocale, fetchLocalizationFile, t, loadLocalizationConfig };
